import { Controller } from "@hotwired/stimulus"
import {
  positionSealedProductsFrameAfterFirstDeck,
  positionSealedProductsFrameAfterFirstRow
} from "../utils/sealed_products_placement"

export default class extends Controller {
  static values = {
    url: String,
    frameId: String,
    placementMode: String,
    bottomClone: Boolean
  }

  connect() {
    this.cloneInserted = false
    this.handleFrameLoad = this.handleFrameLoad.bind(this)
    this.positionFrame = this.positionFrame.bind(this)
    this.schedulePositionFrame = this.schedulePositionFrame.bind(this)

    this.container = this.insertionContainer()
    if (!this.container || this.hasExistingFrame()) return

    this.frame = document.createElement("turbo-frame")
    this.frame.id = this.frameIdValue
    this.frame.setAttribute("src", this.urlValue)
    this.frame.setAttribute("loading", "eager")
    this.frame.classList.add("sealed-products-frame", "article-sealed-products-top")
    this.frame.addEventListener("turbo:frame-load", this.handleFrameLoad)

    if (!this.positionFrame()) {
      this.frame.removeEventListener("turbo:frame-load", this.handleFrameLoad)
      this.frame.remove()
      this.frame = null
      return
    }
    if (this.placementModeValue === "spoiler_row") {
      window.addEventListener("resize", this.schedulePositionFrame)
    }
    if (this.bottomCloneValue) this.cloneLoadedWidget()
  }

  disconnect() {
    window.removeEventListener("resize", this.schedulePositionFrame)
    if (this.positionFrameRequest) cancelAnimationFrame(this.positionFrameRequest)

    if (this.frame) {
      this.frame.removeEventListener("turbo:frame-load", this.handleFrameLoad)
    }
  }

  insertionContainer() {
    if (this.placementModeValue === "first_deck") return this.element

    const firstContainer = this.element.querySelector(".spoiler-card-container, #spoiler-card-container")
    if (!firstContainer) return null

    if (!firstContainer.querySelector(".spoiler-card")) return null

    return firstContainer
  }

  positionFrame() {
    this.positionFrameRequest = null
    if (this.placementModeValue === "first_deck") {
      return positionSealedProductsFrameAfterFirstDeck(this.container, this.frame)
    }
    return positionSealedProductsFrameAfterFirstRow(this.container, this.frame)
  }

  schedulePositionFrame() {
    if (this.positionFrameRequest) return
    this.positionFrameRequest = requestAnimationFrame(this.positionFrame)
  }

  hasExistingFrame() {
    return Array.from(this.element.querySelectorAll("turbo-frame"))
      .some((frame) => frame.id === this.frameIdValue)
  }

  handleFrameLoad() {
    if (!this.frame.querySelector(".sealed-products-widget")) {
      this.frame.remove()
      this.frame = null
      window.removeEventListener("resize", this.schedulePositionFrame)
      if (this.positionFrameRequest) cancelAnimationFrame(this.positionFrameRequest)
      return
    }

    if (this.bottomCloneValue) this.cloneLoadedWidget()
  }

  cloneLoadedWidget() {
    if (this.cloneInserted || !this.frame) return

    const widget = this.frame.querySelector(".sealed-products-widget")
    if (!widget) return

    const wrapper = document.createElement("div")
    wrapper.classList.add("article-sealed-products-clone", "sealed-products-frame")

    const clone = widget.cloneNode(true)
    this.removeStaticIds(clone)
    wrapper.appendChild(clone)
    this.element.appendChild(wrapper)
    this.cloneInserted = true
  }

  removeStaticIds(element) {
    if (element.id) element.removeAttribute("id")
    element.querySelectorAll("[id]").forEach((node) => node.removeAttribute("id"))
  }
}
